import React from 'react';

interface IStateProps {
    isLoading: boolean;
}

interface IExtProps {
    style?: any;
    wrapper?: any;
}

type IProps = IStateProps & IExtProps;
const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

export function LoadingIndicator(props: IProps) {
    return props.isLoading ? (
        <div style={props.wrapper} onClick={handleClick} role="presentation">
            <div className="loading-indicator" style={props.style} />
        </div>
    ) : null;
}
